<template>
    <div class="table-input" v-if="meta.length">
        <template v-if="expanded">
            <div v-for="kgc in meta" :key="kgc._id" class="expanded">
                <vs-button color="danger" type="gradient" class="action-metadata-btn del-kgc"
                                               v-if="deleteMeta"
                                               @click="deleteMeta(kgc)">
                    <i translate="translate" class="material-icons notranslate"> clear </i>
                </vs-button>
                <b>{{kgc.concept_id}}</b> - {{kgc.title}}
            </div>
        </template>
        <template v-else>
            <span v-for="(kgc,i) in meta" :key="kgc._id" class="d-inline-flex pr-1">
                    <vs-button color="danger" type="gradient" class="action-metadata-btn del-kgc"
                               v-if="deleteMeta"
                                           @click="deleteMeta(kgc)">
                    <i translate="translate" class="material-icons notranslate"> clear </i>
                </vs-button>
                {{kgc.concept_id}}<template v-if="i !== meta.length-1">,</template>
            </span>
        </template>
        <div v-if="!expanded" class="pt-2">
            <b @click="expanded=true" style="cursor: pointer;color: #7367f0">Show titles...</b>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            meta: Array,
            deleteMeta: Function,
        },
        data () {
            return {
                expanded: false,
            }
        },
        mounted () {
        },
        methods: {
            expand(item) {

            },
        }
    }
</script>
